import React, { useState, useEffect, useRef, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import './ProfitSharePage.css';
import axios from 'axios';
// import jsPDF from "jspdf";
// import "jspdf-autotable";
import bwipjs from 'bwip-js'; 
import { API_URL } from '../environment';

import { useAuth } from '../../context/AuthContext'; // ✅ Import useAuth correctly
// import { permissions } from "./../permissions"; // ✅ Import permissions

import Datetime from "react-datetime";
import "react-datetime/css/react-datetime.css";
// import betmap from './betmap.json';

import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import moment from "moment";
import * as XLSX from 'xlsx';
import jsPDF from "jspdf";
import "jspdf-autotable";

function ProfitShare() {
  const betmap = {};
  const navigate = useNavigate();
  const { user, login, logout } = useAuth(); // ✅ Now user, login, and logout are accessible

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const [isPopupVisible, setPopupVisible] = useState(false);
  const [popupData, setPopupData] = useState(null);

  const [printData, setPrintData] = useState({});

  const stDay = new Date();
  const stlast30Days = new Date(stDay);
  stlast30Days.setDate(stDay.getDate() - 29);
  const stStartDate = new Date(stlast30Days.setHours(0, 0, 0, 0)).toISOString();
  const stEndDate = new Date(stDay.setHours(23, 59, 59, 999)).toISOString();

  // Now store startDate/endDate at the top level
  const [dateRangeData, setDateRangeData] = useState({
    startDate: stStartDate,
    endDate: stEndDate,
  });

  const [activeItemId, setActiveItemId] = useState(null);
  const [isCalendarVisible, setCalendarVisible] = useState(false);
  // const [selectedDate, setSelectedDate] = useState(null);

  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const limit = 10; // Number of items per page

  const [inputPage, setInputPage] = useState(currentPage);
  const [activeDate, setActiveDate] = useState('LAST_30_DAYS');
  const calendarRef = useRef(null);

// 1) Keep these at the component level
// const [startDate, setStartDate] = useState(null);
// const [endDate, setEndDate] = useState(null);
const [selectingEnd, setSelectingEnd] = useState(false);

const [startDate, setStartDate] = useState("");
const [endDate, setEndDate] = useState("");

const [shopsList, setShopsList] = useState([]);
const [selectedShop, setSelectedShop] = useState('');
const [shopProfitShareRatio, setShopProfitShareRatio] = useState(0);
const [shopLossShareRatio, setShopLossShareRatio] = useState(0);

const [totalGross, setTotalGross] = useState(0);
const [totalGrossCabana, setTotalGrossCabana] = useState(0);
const [totalGrossOwner, setTotalGrossOwner] = useState(0);
const [totalBetTotal, setTotalBetTotal] = useState(0);
const [totalRedeemedTotal, setTotalRedeemedTotal] = useState(0);
const [totalNumTicketsRedeemed, setTotalNumTicketsRedeemed] = useState(0);
const [totalNumTicketsSold, setTotalNumTicketsSold] = useState(0);



// 2) In your date-change handler:
const handleDateChange = async (date) => {
  // If the user is navigating months (returns a string) or typing in something, ignore it:
  if (typeof date === "string") return;

  // Helper function to format dates
  const formatDate = (d, startOfDay = true) => {
    return startOfDay
      ? moment(d).startOf("day").format("YYYY-MM-DD")
      : moment(d).endOf("day").format("YYYY-MM-DD");
  };

  // If no start date is chosen, or if both startDate and endDate are already set, start a new selection:
  if (!startDate || (startDate && endDate)) {
    setStartDate(date);
    setEndDate(null);
    setSelectingEnd(true);
  } else {
    let newStartDate = startDate;
    let newEndDate = date;

    // If the user picks an earlier day than startDate, swap them:
    if (date.isBefore(startDate, "day")) {
      newStartDate = date;
      newEndDate = startDate;
    }

    // If startDate and endDate are the same, extend the end date by one day
    // if (newStartDate.isSame(newEndDate, "day")) {
    //   newEndDate = moment(newEndDate).add(1, "day");
    // }

    setStartDate(newStartDate);
    setEndDate(newEndDate);
    setSelectingEnd(false);

    // Format the dates for API call
    const formattedStart = formatDate(newStartDate, true);
    const formattedEnd = formatDate(newEndDate, false);

    // Update the date range state
    setDateRangeData({
      startDate: formattedStart,
      endDate: formattedEnd,
    });

    // Fetch updated reports
    // await refreshShiftsHistory(formattedStart, formattedEnd, 1);
  }
};


// Helper to convert a picked day to "YYYY-MM-DD" (if that's your backend format)
function dateToISO(day, startOfDay = true) {
  if (!day) return "";
  const d = startOfDay
    ? moment(day).startOf("day")
    : moment(day).endOf("day");
  // Returns "YYYY-MM-DD"
  return d.format("YYYY-MM-DD");
}


// const sampleData = {
//   shopName: "Players Night Club",
//   startDay: "Jul 23, 2025, 12:05:00 AM",
//   endDay: "Jul 24, 2025, 12:03:00 AM",
//   page: 1,
//   pages: 1,
//   shifts: 1,
//   cashier: {
//     name: "1 Cashier Name (STATUS)",
//     soldCount: 5,
//     redeemedCount: 2,
//     soldAmount: 4000,
//     redeemedAmount: 2000,
//     shiftStart: "23 Jul 25 10:13AM",
//     shiftEnd: "24 Jul 25 02:13AM",
//   },
//   totals: {
//     sold: 4000,
//     redeemed: 2000,
//     eligible: -1000,
//     gross: 1000,
//   },
//   split: {
//     ownerPct: 35,
//     shopPct: 65,
//     owner: 350,
//     shop: 650,
//   },
// };

 

 const generatePDF = () => {
  const doc = new jsPDF({
    orientation: 'portrait',
    unit: 'in',
    format: [3.12, 9.8] // Initial height, will recalculate later
  });

  const fmtMoney = n => (n < 0 ? `-$${Math.abs(n).toLocaleString()}` : `$${n.toLocaleString()}`);

  const hr = (doc, y) => {
    doc.setLineWidth(0.5);
    doc.line(15, y, doc.internal.pageSize.getWidth() - 15, y);
  };

  const pageW = doc.internal.pageSize.getWidth();
  const left = 0.2;
  let y = 0.3;

  doc.setFont("helvetica", "bold");
  doc.setFontSize(14);
  doc.text("ROULETTE", pageW/2, y, { align: "center" });
  y += 0.5;

  doc.setTextColor(200, 0, 0);
  doc.setFontSize(12);
  doc.text(data.shopName || "Players Night Club", pageW/2, y, { align: "center" }); 
  y += 0.2;

   doc.setTextColor(0,0,0);
   doc.setFont("courier", "normal");
   doc.setFontSize(9);
   const dots = "**********************************************";
   doc.text(dots, pageW/2, y += 0.2, { align: "center" });
 
  //  // Period
   doc.setFont("helvetica", "bold"); doc.setFontSize(11);
   doc.text("Profit Share", left, y += 0.2);

   doc.setFont("helvetica", "normal"); doc.setFontSize(10);
   doc.setTextColor(200,0,0);
   doc.text(`Start Day: ${printData.startDay}`, left, y += 0.2);
   doc.text(`End Day: ${printData.endDay}`, left, y += 0.2);

  //  // Pages / Shifts
   doc.setTextColor(255,0,0);
   doc.text(`Pages: ${printData.page} of ${printData.pages}`, left, y += 0.2);
   doc.text(`Cashier Shifts: ${printData.shifts}`, left, y += 0.2);

   doc.setTextColor(0,0,0);
   doc.text(dots, pageW/2, y += 0.2, { align: "center" });




  //  // Cashier table (simple)
   y += 0.4;
   doc.setFont("helvetica","bold");
   doc.text("Cashier", left, y);
   doc.text("Sold", left + 300, y);
   doc.text("Redeemed", left + 380, y);
   //  hr(doc, y+0.5);

   y += 0.5;
   doc.setFont("helvetica","normal");
   doc.setTextColor(255,0,0);
   doc.text(`${printData.cashier.name}`, left, y);
   doc.text(String(printData.cashier.soldCount), left + 300, y);
   doc.text(String(printData.cashier.redeemedCount), left + 380, y);

   doc.setTextColor(255,0,0);
   doc.text(`S: ${printData.cashier.shiftStart}`, left, y += 0.2);
   doc.text(fmtMoney(printData.cashier.soldAmount), left + 300, y);
   doc.text(fmtMoney(-Math.abs(printData.cashier.redeemedAmount)), left + 380, y);

   doc.text(`E: ${printData.cashier.shiftEnd}`, left, y += 0.2);





   // Big gap like in receipt
   //  y += 2;
   y += 0.4;
   doc.text(dots, pageW/2, y, { align: "center" }); y += 0.2;

   // Totals
   doc.setFont("helvetica","bold");
   doc.setTextColor(255,0,0);
   doc.text(`TOTAL SOLD:          ${fmtMoney(printData.totals.sold)}`, left, y);
   doc.text(`TOTAL REDEEMED:      ${fmtMoney(-Math.abs(printData.totals.redeemed))}`, left, y += 0.2);
   doc.text(`TOTAL ELIGIBLE:      ${fmtMoney(printData.totals.eligible)}`, left, y += 0.2);
   doc.setTextColor(0,0,0);
   doc.text(`TOTAL GROSS:         ${fmtMoney(printData.totals.gross)}`, left, y += 0.2);

   doc.setTextColor(0,0,0);
   doc.text(dots, pageW/2, y += 0.3, { align: "center" }); y += 0.2;

   // Split
   doc.setFont("helvetica","bold");
   doc.setTextColor(255,0,0);
   doc.text(`OWNER GROSS (${printData.split.ownerPct}%):   ${fmtMoney(printData.split.owner)}`, left, y);
   doc.text(`SERVICE PROVIDER GROSS (${printData.split.shopPct}%): ${fmtMoney(printData.split.shop)}`, left, y += 0.2);

   // Footer
   doc.setTextColor(0,0,0);
   doc.text(dots, pageW/2, y += 0.2, { align: "center" });
   doc.setFontSize(12); doc.setFont("helvetica","bold");
   doc.text("THANK YOU", pageW/2, y += 0.2, { align: "center" });
  
  //  doc.save(`ProfitShareReport.pdf`);
  //  return;
  

  // Automatically open the print dialog
  doc.autoPrint();

  // Open the PDF directly in a new browser tab
  const pdfBlob = doc.output("blob");
  const blobURL = URL.createObjectURL(pdfBlob);
  const iframe = document.createElement("iframe");
  iframe.style.position = "fixed";
  iframe.style.top = "0";
  iframe.style.left = "0";
  iframe.style.width = "1px";
  iframe.style.height = "1px";
  iframe.style.border = "none";
  iframe.src = blobURL;

  iframe.onload = () => {
    iframe.contentWindow.focus();
    iframe.contentWindow.print(); // Trigger print directly
  };

  document.body.appendChild(iframe);
  // Clean up the iframe after printing
  setTimeout(() => {
    document.body.removeChild(iframe);
  }, 2000);






  // Create blob and URL for iframe display
  // const pdfBlob = doc.output("blob");
  // const pdfURL = URL.createObjectURL(pdfBlob);
  
  // // Create or get existing pdfViewer element
  // let pdfViewer = document.getElementById("pdfViewer");
  // if (!pdfViewer) {
  //   pdfViewer = document.createElement("div");
  //   pdfViewer.id = "pdfViewer";
  //   pdfViewer.style.position = "fixed";
  //   pdfViewer.style.top = "50%";
  //   pdfViewer.style.left = "50%";
  //   pdfViewer.style.transform = "translate(-50%, -50%)";
  //   pdfViewer.style.zIndex = "9999";
  //   pdfViewer.style.backgroundColor = "white";
  //   pdfViewer.style.padding = "20px";
  //   pdfViewer.style.borderRadius = "8px";
  //   pdfViewer.style.boxShadow = "0 4px 20px rgba(0,0,0,0.3)";
  //   pdfViewer.style.maxWidth = "90vw";
  //   pdfViewer.style.maxHeight = "90vh";
  //   pdfViewer.style.overflow = "auto";
  // }
  
  // pdfViewer.innerHTML = `
  //   <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 10px;">
  //     <h3 style="margin: 0;">Profit Share Report</h3>
  //     <button onclick="this.parentElement.parentElement.remove()" style="background: #ff4444; color: white; border: none; padding: 5px 10px; border-radius: 4px; cursor: pointer;">Close</button>
  //   </div>
  //   <iframe src="${pdfURL}" width="100%" height="500px" style="border: none;"></iframe>
  // `;
  
  // document.body.appendChild(pdfViewer);
 };

  useEffect(() => {
    document.body.classList.add('validate-active');
    handleDateRange("LAST_30_DAYS");
    return () => {
      document.body.classList.remove('validate-active');
    };
  }, []);

  useEffect(() => {
    // Load tickets whenever currentPage changes
    // const { startDate, endDate } = dateRangeData;

    const loadBettingShops = async() => {
      const responseShopsList = await axios.get(`${API_URL}/bettingshops`); // Example API URL
      let shopsListRes = (responseShopsList.data || []).reverse();
      // filter shops by user permissions

      const allowedShopIds = localStorage.getItem('sun_bettingShopsList').split(',') || []

      let filteredShops = shopsListRes.concat();
      if (allowedShopIds.length) {
        filteredShops = filteredShops.filter(o => allowedShopIds.includes(o._id));
      }

      setShopsList(filteredShops);
      let shopId = '';
      if (filteredShops.length) {
        setSelectedShop(filteredShops[0]._id);
        setShopProfitShareRatio(filteredShops[0].profitShare || 0);
        setShopLossShareRatio(filteredShops[0].lossShare || 0);
        shopId = filteredShops[0]._id;
      }
      return shopId;
    };

    loadBettingShops().then((shopId)=>{
      setSelectedShop(shopId);
      // refreshShiftsHistory(startDate, endDate, currentPage, firstShopId);
    });

  }, []);

  // ✅ Function to check access
  // const hasAccess = (path) => user && permissions[user.role]?.includes(path);




  // Common fetch function
  // const refreshShiftsHistory = useCallback(async (custStartDate, custEndDate, page = 1) => {
  
  useEffect(() => {
    // let custStartDate = startDate;
    // let custEndDate = endDate;
    if(!selectedShop) return;
    const refreshShiftsHistory = async () => {
      setLoading(true);
      try {
        let reportsParams = { page: currentPage, limit: 1000 };

        const formatDate = (date, startOfDay = true) =>
          startOfDay
            ? new Date(date).toISOString().split('T')[0] + 'T00:00:00.000Z'
            : new Date(date).toISOString().split('T')[0] + 'T23:59:59.999Z';

        // If dateRangeData already has them, use them
        if (dateRangeData.startDate) {
          reportsParams.startDate = dateRangeData.startDate;
        }
        if (dateRangeData.endDate) {
          reportsParams.endDate = dateRangeData.endDate;
        }

        // If function arguments are provided, they override
        // if (custStartDate) {
        //   reportsParams.startDate = formatDate(custStartDate, true);
        // }
        // if (custEndDate) {
        //   reportsParams.endDate = formatDate(custEndDate, false);
        // }




        // Choose the timezone you want the backend to treat as "the day".
        // - Use browser TZ (default) to match how the user picked TODAY/YESTERDAY.
        // - Or hardcode your business TZ like 'Europe/Uzhgorod' if needed.
        const DEFAULT_TZ = Intl.DateTimeFormat().resolvedOptions().timeZone;
        // const REPORTS_TZ = "Europe/Uzhgorod";
        const REPORTS_TZ = DEFAULT_TZ;

        const convertToDateOnly = (value, timeZone = REPORTS_TZ) => {
          if (!value) return "";

          // If it's already YYYY-MM-DD, keep it as-is
          if (/^\d{4}-\d{2}-\d{2}$/.test(value)) return value;

          const d = new Date(value);
          if (Number.isNaN(d.getTime())) return "";

          // Build YYYY-MM-DD in the requested timezone (not UTC)
          const parts = new Intl.DateTimeFormat("en-CA", {
            timeZone,
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
          }).formatToParts(d);

          const y = parts.find((p) => p.type === "year")?.value;
          const m = parts.find((p) => p.type === "month")?.value;
          const da = parts.find((p) => p.type === "day")?.value;

          return `${y}-${m}-${da}`;
        };

        const ONE_DAY_MS = 24 * 60 * 60 * 1000;

        if (reportsParams.startDate && reportsParams.endDate) {
          const startMs = Date.parse(reportsParams.startDate);
          const endMs = Date.parse(reportsParams.endDate);

          const startDay = convertToDateOnly(reportsParams.startDate);
          const endDay = convertToDateOnly(reportsParams.endDate);

          // Best: use an explicit flag if you have it:
          // const singleDayPreset =
          //   reportsParams.activeDateSelected === "TODAY" ||
          //   reportsParams.activeDateSelected === "YESTERDAY";

          // Fallback: detect the "single-day preset" by duration (< 24h)
          const singleDayPreset =
            Number.isFinite(startMs) &&
            Number.isFinite(endMs) &&
            endMs - startMs < ONE_DAY_MS;

          reportsParams.startDate = startDay;
          reportsParams.endDate = singleDayPreset ? startDay : endDay;
        } else {
          if (reportsParams.startDate) {
            reportsParams.startDate = convertToDateOnly(reportsParams.startDate);
          }
          if (reportsParams.endDate) {
            reportsParams.endDate = convertToDateOnly(reportsParams.endDate);
          }
        }




        // filter by selectedShop
        reportsParams.bettingShopId = selectedShop;
        // reportsParams.status = "CLOSE";
        reportsParams.isProfitShare = "true";
        console.log('reportsParams', reportsParams);
        const response = await axios.get(`${API_URL}/shiftpages`, {
          params: reportsParams, // Pass params dynamically
        });

        const resData = (response && response.data) || [];
        let formattedData = resData.tickets || [];
        setTotalPages(resData.totalPages || 1);

        // Format date/time
        formattedData = formattedData.map((o) => {
          const date = new Date(o.createdAt);
          const formattedTime = new Intl.DateTimeFormat('en-US', {
            month: 'short',
            day: '2-digit',
            // year: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit',
            hour12: true,
          }).format(date);
          o.createdAtF = formattedTime;

          if (o.startedShiftAt) {
            o.startedShiftAtF = new Intl.DateTimeFormat('en-US', {
              month: 'short',
              day: '2-digit',
              // year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              hour12: true,
            }).format(new Date(o.startedShiftAt)); 
          } else {
            o.startedShiftAtF = 'N/A';
          }

          if (o.endedShiftAt) {
            o.endedShiftAtF = new Intl.DateTimeFormat('en-US', {
              month: 'short',
              day: '2-digit',
              // year: 'numeric',
              hour: '2-digit',
              minute: '2-digit',
              hour12: true,
            }).format(new Date(o.endedShiftAt)); 
          } else {
            o.endedShiftAtF = 'N/A';
          }

          const betShops = shopsList || [];
          const curShop = betShops.find(o => o._id === selectedShop);

          const profitShareRatio = (curShop?.profitShare || 0) / 100;
          const lossShareRatio = (curShop?.lossShare || 0) / 100;

          o.gross = o.stats?.betTotal - o.stats?.redeemedTotal;
          // condition to use profit share or loss share
          if (o.gross >= 0) {
            o.grossCabana = Math.round(o.gross * profitShareRatio);
            o.grossOwner = Math.round(o.gross * (1-profitShareRatio));
          } else {
            o.grossCabana = Math.round(o.gross * lossShareRatio);
            o.grossOwner = Math.round(o.gross * (1-lossShareRatio));
          }

          return o;
        });

        setData(formattedData);

        // console.log('formattedData', formattedData);
        // set total data

        const totals = formattedData.reduce((acc, item) => {
          acc.totalGross += item.gross || 0;
          acc.totalGrossCabana += item.grossCabana || 0;
          acc.totalGrossOwner += item.grossOwner || 0;
          acc.totalBetTotal += (item.stats?.betTotal || 0);
          acc.totalRedeemedTotal += (item.stats?.redeemedTotal || 0);
          acc.totalNumTicketsRedeemed += (item.stats?.numTicketsRedeemed || 0);
          acc.totalNumTicketsSold += (item.stats?.numTicketsSold || 0);
          return acc;
        }, { totalGross: 0, totalGrossCabana: 0, totalGrossOwner: 0, 
          totalBetTotal: 0, totalRedeemedTotal: 0, totalNumTicketsRedeemed: 0, totalNumTicketsSold: 0, });

        setTotalGross(totals.totalGross);
        setTotalGrossCabana(totals.totalGrossCabana);
        setTotalGrossOwner(totals.totalGrossOwner);
        setTotalBetTotal(totals.totalBetTotal);
        setTotalRedeemedTotal(totals.totalRedeemedTotal);
        setTotalNumTicketsRedeemed(totals.totalNumTicketsRedeemed);
        setTotalNumTicketsSold(totals.totalNumTicketsSold);

        // console.log('totals', totals);

        if (formattedData.length) {
          const pStartDay = moment(startDate).format("MMM DD, YYYY");
          const pEndDay = moment(endDate).format("MMM DD, YYYY");

          // ! TODO: add loop instead of cashier






          const cashier1 = formattedData[0];


          const firstCashier = {
            name: `${cashier1?.agentId?.name} (${cashier1?.status})`,
            soldCount: cashier1?.stats?.numTicketsSold,
            redeemedCount: cashier1?.stats?.numTicketsRedeemed,
            soldAmount: cashier1?.stats?.betTotal,
            redeemedAmount: cashier1?.stats?.redeemedTotal,
            shiftStart: cashier1.startedShiftAtF,
            shiftEnd: cashier1.endedShiftAtF,
          };

          let pData = {
            shopName: cashier1?.bettingShopId?.name,
            startDay: pStartDay,
            endDay: pEndDay,
            page: 1,
            pages: 1,
            shifts: 1,
            cashier: firstCashier,
            totals: {
              sold: cashier1?.stats?.betTotal,
              redeemed: cashier1?.stats?.redeemedTotal,
              eligible: 0,
              gross: cashier1?.gross,
            },
            split: {
              ownerPct: 35,
              shopPct: 65,
              owner: cashier1?.grossCabana,
              shop: cashier1?.grossOwner,
            },
          };

          setPrintData( pData );
        }

        setLoading(false);
      } catch (err) {
        console.log(err);
        setLoading(false);
      }
    }
    refreshShiftsHistory();
  }, [dateRangeData, selectedShop, shopsList, currentPage]);

  // handle change betiing shop
  const handleInputChange = (e) => {
    const shopId = e.target.value;
    const curShop = shopsList.find(o => o._id === shopId);

    setSelectedShop(shopId);
    if (curShop) {
      setShopProfitShareRatio(curShop.profitShare || 0);
      setShopLossShareRatio(curShop.lossShare || 0);
    }

    // const { startDate, endDate } = dateRangeData;
    // refreshShiftsHistory(startDate, endDate, 1, shopId);
  };

  // Toggle pages
  const handlePageInput = (e) => {
    setInputPage(e.target.value);
  };

  const goToPage = (page) => {
    const pageNum = Math.max(1, Math.min(totalPages, page));
    setCurrentPage(pageNum);
    setInputPage(pageNum);
  }; 

  const handleDateRange = useCallback(
    async (range) => {
      const today = new Date();
      let startDate, endDate;
  
      if (range === "CUSTOM") {
        setCalendarVisible((prev) => !prev);
        setActiveDate('CUSTOM');
        return;
      }
  
      let activeDateSelected = '';
  
      switch (range) {
        case "TODAY":
          startDate = new Date(today.setHours(0, 0, 0, 0)).toISOString();
          endDate = new Date(today.setHours(23, 59, 59, 999)).toISOString();
          activeDateSelected = "TODAY";
          break;
  
        case "YESTERDAY":
          const yesterday = new Date(today);
          yesterday.setDate(today.getDate() - 1);
          startDate = new Date(yesterday.setHours(0, 0, 0, 0)).toISOString();
          endDate = new Date(yesterday.setHours(23, 59, 59, 999)).toISOString();
          activeDateSelected = "YESTERDAY";
          break;
  
        case "LAST_7_DAYS":
          const last7Days = new Date(today);
          last7Days.setDate(today.getDate() - 6);
          startDate = new Date(last7Days.setHours(0, 0, 0, 0)).toISOString();
          endDate = new Date(today.setHours(23, 59, 59, 999)).toISOString();
          activeDateSelected = "LAST_7_DAYS";
          break;
  
        case "LAST_30_DAYS":
          const last30Days = new Date(today);
          last30Days.setDate(today.getDate() - 29);
          startDate = new Date(last30Days.setHours(0, 0, 0, 0)).toISOString();
          endDate = new Date(today.setHours(23, 59, 59, 999)).toISOString();
          activeDateSelected = "LAST_30_DAYS";
          break;
  
        default:
          startDate = "";
          endDate = "";
          break;
      }
  
      const formatDate = (d, startOfDay = true) => {
        return startOfDay
          ? moment(d).startOf("day").toISOString()
          : moment(d).endOf("day").toISOString();
      };
    
      // Format the dates for API call
      const formattedStart = formatDate(startDate, true);
      const formattedEnd = formatDate(endDate, false);

      // Update the date range state
      setDateRangeData({
        startDate: formattedStart,
        endDate: formattedEnd,
      });

      setActiveDate(activeDateSelected);
  
      const convertToDateOnly = (isoString) =>
        isoString ? new Date(isoString).toISOString().split("T")[0] : "";
  
      // startDate = convertToDateOnly(startDate);
      // endDate = convertToDateOnly(endDate);
  
      setStartDate(startDate);
      setEndDate(endDate);
  
      // await refreshShiftsHistory(startDate, endDate, 1);
  
      console.log("Date Range Selected:", { startDate, endDate });
    },
    []
  );

  // Initial load: set to "TODAY"
  // useEffect(() => {
  //   handleDateRange("LAST_30_DAYS");
  // }, [handleDateRange]);
  

  const formatStringWithHyphens = (input) => {
    // Ensure the input is a string of 12 characters
    if (typeof input !== 'string' || input.length !== 12) {
      return '-';
    }
    return input.match(/.{1,4}/g).join('-');
  };


  const backMainMenu = () => {
    navigate('/dashboard');
  };

  // const handleExport = async() => {


  //   let reportsParams = { page: 1, limit: 1000 };

  //   const formatDate = (date, startOfDay = true) =>
  //     startOfDay
  //       ? new Date(date).toISOString().split('T')[0] + 'T00:00:00.000Z'
  //       : new Date(date).toISOString().split('T')[0] + 'T23:59:59.999Z';


  //   // If dateRangeData already has them, use them
  //   if (dateRangeData.startDate) {
  //     reportsParams.startDate = formatDate(dateRangeData.startDate, true);
  //   }
  //   if (dateRangeData.endDate) {
  //     reportsParams.endDate = formatDate(dateRangeData.endDate, false);
  //   }

  //   // If function arguments are provided, they override
  //   // if (custStartDate) {
  //   //   reportsParams.startDate = formatDate(custStartDate, true);
  //   // }
  //   // if (custEndDate) {
  //   //   reportsParams.endDate = formatDate(custEndDate, false);
  //   // }
  //   // reportsParams.status = "CLOSE";
  //   reportsParams.isProfitShare = "true";
  //   const response = await axios.get(`${API_URL}/shiftpages`, {
  //     params: reportsParams,
  //   });

  //   const resData = (response && response.data) || [];
  //   let formattedData = resData.tickets || [];

  //   // Format date/time
  //   formattedData = formattedData.map((o) => {
  //     const date = new Date(o.createdAt);
  //     const formattedTime = new Intl.DateTimeFormat('en-US', {
  //       month: 'short',
  //       day: '2-digit',
  //       // year: 'numeric',
  //       hour: '2-digit',
  //       minute: '2-digit',
  //       second: '2-digit',
  //       hour12: true,
  //     }).format(date);
  //     o.createdAtF = formattedTime;

  //     if (o.startedShiftAt) {
  //       o.startedShiftAtF = new Intl.DateTimeFormat('en-US', {
  //         month: 'short',
  //         day: '2-digit',
  //         // year: 'numeric',
  //         hour: '2-digit',
  //         minute: '2-digit',
  //         hour12: true,
  //       }).format(new Date(o.startedShiftAt)); 
  //     } else {
  //       o.startedShiftAtF = 'N/A';
  //     }

  //     if (o.endedShiftAt) {
  //       o.endedShiftAtF = new Intl.DateTimeFormat('en-US', {
  //         month: 'short',
  //         day: '2-digit',
  //         // year: 'numeric',
  //         hour: '2-digit',
  //         minute: '2-digit',
  //         hour12: true,
  //       }).format(new Date(o.endedShiftAt)); 
  //     } else {
  //       o.endedShiftAtF = 'N/A';
  //     }

  //     const expectedEndTotal = o.stats?.startTotal + o.stats?.floatIncreaseTotal + o.stats?.betTotal - o.stats?.redeemedTotal;
  //     o.variation = o.stats?.endTotal - expectedEndTotal;

  //     o.gross = o.stats?.betTotal - o.stats?.redeemedTotal;

  //     return o;
  //   });

  //   const dataToExport = formattedData.map(item => ({
  //     'SHIFT ID': item._id || '--',
  //     'AGENT': item.agentId?.name || '--',
  //     'STATUS': item.status, // (item.shiftActive ? 'Open' : 'Close'),
  //     'OPEN TOTAL': item.stats?.startTotal,
  //     'FLOAT INCREASE TOTAL': item.stats?.floatIncreaseTotal,
  //     'TICKETS SOLD QTY': `${item.stats?.numTicketsSold}`,
  //     'TICKETS SOLD': `${item.stats?.betTotal}`,
  //     'TICKETS REDEEMED QTY': `${item.stats?.numTicketsRedeemed}`,
  //     'TICKETS REDEEMED': `-${item.stats?.redeemedTotal}`,
  //     'CLOSE TOTAL': item.stats?.endTotal,
  //     'BALANCE': (item.shiftBalance ? 'Yes' : 'No'),
  //     'VARIATION': item.variation,
  //     'SHIFT START': item.startedShiftAtF,
  //     'SHIFT END': item.endedShiftAtF,
  //   }));

  //   const worksheet = XLSX.utils.json_to_sheet(dataToExport);
  //   const workbook = XLSX.utils.book_new();
  //   XLSX.utils.book_append_sheet(workbook, worksheet, 'Reports');

  //   const { startDate, endDate } = dateRangeData;
  //   const formattedStart = moment(startDate).format("DDMMMYYYY");
  //   const formattedEnd = moment(endDate).format("DDMMMYYYY");

  //   const fileName =
  //     formattedStart === formattedEnd
  //       ? formattedStart
  //       : `${formattedStart}_${formattedEnd}`;

  //   XLSX.writeFile(workbook, `ShiftHistory_${fileName}.xlsx`);
  // };

  const formatCurrency = (value) => {
    if (typeof value !== "number") {
      return '-'; // throw new Error("Input must be a number");
    }
  
    return value.toLocaleString("en-US", {
      minimumFractionDigits: 0,
      maximumFractionDigits: 0,
    });
  };


  return (
    <>
      {/* <button onClick={handleExport} className="btn-export">
        Export to Excel
      </button> */}
      <div className="validate validate-history">
        <div className="validate-top-wrap">
          <div className="validate_top-left">
            <div className="spin-border dashbord-border">
              <div className="spin-light spin-light-top">
                <div className="spin-light-container">
                  {Array.from({ length: 15 }).map((_, index) => (
                    <div
                      className="spin-light-item"
                      style={{ animationDelay: `${index * 0.2}s` }}
                      key={index}
                    ></div>
                  ))}
                </div>
              </div>
              <div className="spin-number">
                <div className="spin-number__text">
                  <span className="spin-number__text-big">PROFIT SHARE</span>
                </div>
              </div>
              <div className="spin-light spin-light-bottom">
                <div className="spin-light-container">
                  {Array.from({ length: 15 }).map((_, index) => (
                    <div
                      className="spin-light-item"
                      style={{ animationDelay: `${index * 0.2}s` }}
                      key={index}
                    ></div>
                  ))}
                </div>
              </div>
            </div>
          </div>
          <div className="validate_top-middel">
          {!startDate ? (
  // If no startDate at all:
  "No date selected"
) : !endDate || moment(startDate).isSame(endDate, "day") ? (
  // If endDate is null OR both dates are the same day:
  (() => {
    const date = moment(startDate);

    // If it's exactly "today":
    if (moment().isSame(date, "day")) {
      return date.format("MMM DD, YYYY"); // e.g. "Feb 21, 2025"
    }
    // If it's exactly "yesterday":
    if (moment().subtract(1, "days").isSame(date, "day")) {
      return date.format("MMM DD, YYYY");
    }
    // Otherwise, just return the single date
    return date.format("MMM DD, YYYY");
  })()
) : (
  // If we have a valid range (two different days):
  (() => {
    const start = moment(startDate);
    const end = moment(endDate);
    const rangeDays = end.diff(start, "days");

    // If the range is exactly 1 day, just show the end date
    if (rangeDays === 1) {
      return start.format("MMM DD, YYYY");
    }

    // If the end date is "today" and range > 1
    if (moment().isSame(end, "day") && rangeDays > 1) {
      return (
        <>
          {start.format("MMM DD, YYYY")}
          {" - "}
          {end.format("MMM DD, YYYY")}
        </>
      );
    }

    // If the end date is "today" and range <= 2
    if (moment().isSame(end, "day") && rangeDays <= 2) {
      return "Today";
    }

    // If the end date is "yesterday" and range <= 2
    if (moment().subtract(1, "days").isSame(end, "day") && rangeDays <= 2) {
      return "Yesterday";
    }

    // Default: "start - end" format
    if (activeDate === 'LAST_7_DAYS' || activeDate === 'LAST_30_DAYS') {
      return (
        <>
          {start.format("MMM DD, YYYY")}
          {" - "}
          {end.subtract(1, "days").format("MMM DD, YYYY")}
        </>
      );
    }
    return (
      <>
        {start.format("MMM DD, YYYY")}
        {" - "}
        {end.format("MMM DD, YYYY")}
      </>
    );
  })()
)}

          </div>

          <div className="validate_top-right">
            <button className="return-menu btn-yellow" onClick={backMainMenu}>
              RETURN TO MAIN MENU
            </button>
          </div>
        </div>

        <div className="validate-bottom-wrap shift-top-adj">
          <div className="report_filter-date report_filter-date-valid">

            <div className="report_filter-date-sl">
              <select
                className="betting-form__input betting-form__input-width-sl"
                name="role"
                value={selectedShop}
                onChange={handleInputChange}
              >
                <option value="" disabled>
                  Select Shop
                </option>
                {shopsList.map((shop) => (
                  <option key={shop._id} value={shop._id}>
                    {shop.name}
                  </option>
                ))}
              </select>
            </div>

            <div
              className={`report_filter-date-item ${activeDate==='TODAY' ? "date-active" : ""}`}
              onClick={() => handleDateRange("TODAY")}
            >
              TODAY
            </div>
            <div
              className={`report_filter-date-item ${activeDate==='YESTERDAY' ? "date-active" : ""}`}
              onClick={() => handleDateRange("YESTERDAY")}
            >
              YESTERDAY
            </div>
            <div
              className={`report_filter-date-item ${activeDate==='LAST_7_DAYS' ? "date-active" : ""}`}
              onClick={() => handleDateRange("LAST_7_DAYS")}
            >
              LAST 7 DAYS
            </div>
            <div
              className={`report_filter-date-item ${activeDate==='LAST_30_DAYS' ? "date-active" : ""}`}
              onClick={() => handleDateRange("LAST_30_DAYS")}
            >
              LAST 30 DAYS
            </div>
            <div
              className={`report_filter-date-item-custom report_filter-date-item ${activeDate==='CUSTOM' ? "date-active" : ""}`}
              onClick={() => handleDateRange("CUSTOM")}
            >
              <span className="report_filter-date-custom-span">CUSTOM</span>
            </div>
            {/* <div
              className={'report_filter-date-item'}
              onClick={() => generatePDF()}
            >
              PRINT
            </div> */}

            {isCalendarVisible && (
              <div className="calendar-container">
                <Datetime
                  onChange={handleDateChange}
                  open={true}
                  input={false}
                  timeFormat={false}
                  closeOnSelect={false}
                  ref={calendarRef}
                  isValidDate={(current) => {
                    // Allow all dates when selecting start
                    if (!startDate || !selectingEnd) return true;
                  
                    // When selecting end, it must be same or after start
                    return moment(current).isSameOrAfter(startDate, "day");
                  }}
                  renderDay={(props, currentDate, selectedDate) => {
            
                    let className = props.className;
                    if (startDate && endDate) {
                      if (currentDate.isBetween(startDate, endDate, "day", "[]")) {
                        className += " rdt-day-in-range";
                      }
                      if (currentDate.isSame(startDate, "day")) {
                        className += " rdt-day-start";
                      }
                      if (currentDate.isSame(endDate, "day")) {
                        className += " rdt-day-end";
                      }
                    } else if (startDate && !endDate) {
                      if (currentDate.isSame(startDate, "day")) {
                        className += " rdt-day-start";
                      }
                    }
                    return (
                      <td {...props} className={className}>
                        {currentDate.date()}
                      </td>
                    );
                  }}

                
                  renderView={(mode, renderDefault, viewProps) => {
   
                    const defaultCalendar = renderDefault();
                    return (
                      <div>
                        {defaultCalendar}
             
                        <div style={{ textAlign: "center", marginTop: 8 }}>
                          <button
                            className="btn-ok"
                            onClick={() => {
          
                              setCalendarVisible(false);
                         
                            }}
                          >
                            OK
                          </button>
                        </div>
                      </div>
                    );
                  }}
                />
              </div>
            )}
            
          </div>


          
          <div className="prof-share-info-wrp report-info">
            <div className="spin-report ">
              <div className="spin-report-light spin-report-light-top">
                <div className="spin-report-light-container">
                  {Array.from({ length: 25 }).map((_, index) => (
                    <div className="spin-report-light-item" style={{ animationDelay: `${index * 0.2}s` }} key={index}></div>
                  ))}
                </div>
              </div>

              <div className="spin-report-info spin-number ">
                <div className="spin-report-info__item pf-item">
                  <div className="spin-report-info-top spin-rep-height">{totalNumTicketsSold} (${formatCurrency(totalBetTotal)})</div>
                  <div className="spin-report-info-bottom bot-pf-item one-color">T. SOLD</div>
                </div>                
                <div className="spin-report-info__item pf-item">
                  <div className="spin-report-info-top spin-rep-height">{totalNumTicketsRedeemed} (${formatCurrency(totalRedeemedTotal)})</div>
                  <div className="spin-report-info-bottom bot-pf-item two-color">T. REDEEMED</div>
                </div>
                <div className="spin-report-info__ite pf-item">
                  <div className="spin-report-info-top spin-rep-height">${formatCurrency(totalGross)}</div>
                  <div className="spin-report-info-bottom bot-pf-item two-color">GROSS</div>
                </div>
                <div className="spin-report-info__item pf-item">
                  <div className="spin-report-info-top spin-rep-height">${formatCurrency(totalGrossOwner)}</div>
                  <div className="spin-report-info-bottom bot-pf-item three-color">OWNER</div>
                </div>
                <div className="spin-report-info__item pf-item">
                  <div className="spin-report-info-top spin-rep-height">${formatCurrency(totalGrossCabana)}</div>
                  <div className="spin-report-info-bottom bot-pf-item three-color">SERVICE PROVIDER</div>
                </div>
              </div>

              <div className="spin-report-light spin-report-light-bottom">
                <div className="spin-report-light-container">
                  {Array.from({ length: 25 }).map((_, index) => (
                    <div className="spin-report-light-item" style={{ animationDelay: `${index * 0.2}s` }} key={index}></div>
                  ))}
                </div>
              </div>
            </div>
          </div>


          <div className="validate-bot-wrap bot-wrap-pf">
            <div className={`validate-left ${isPopupVisible ? "active-class" : ""}`}>
            <div className="table-maket table-maket-ps">
                    <table>
                      <thead>
                        <tr>
                          <th>CASHIER</th>
                          <th>STATUS</th>
                          <th>TICKETS SOLD</th>
                          <th>TICKETS REDEEMED</th>
                          <th>GROSS</th>
                          <th>OWNER ({100 - shopProfitShareRatio}P {100 - shopLossShareRatio}L)</th>
                          <th>SERVICE PROVIDER ({shopProfitShareRatio}P {shopLossShareRatio}L)</th>
                          <th>SHIFT START</th>
                          <th>SHIFT END</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data.map((item) => (
                          <tr key={item._id}>
                            {/* <td className="ticket-id-format table-maket-col_yellow">
                              {item._id}
                            </td> */}
                            <td>{item.agentId?.name}</td>
                            <td>{item?.status}</td>
                            <td>{item.stats?.numTicketsSold} (${item.stats?.betTotal})</td>
                            <td>{item.stats?.numTicketsRedeemed} ($-{item.stats?.redeemedTotal})</td>
                            <td>${item.gross}</td>
                            <td>${item.grossOwner}</td>
                            <td>${item.grossCabana}</td>
                            <td>{item.startedShiftAtF}</td>
                            <td>{item.endedShiftAtF}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>

                  <div className="pagination">
                    {/* Previous Button */}
                    <button
                      className="prev"
                      onClick={() => goToPage(currentPage - 1)}
                      disabled={currentPage === 1}
                    >
                      &laquo;
                    </button>

                    {/* Always show first page */}
                    <button
                      className={`page ${currentPage === 1 ? "active" : ""}`}
                      onClick={() => goToPage(1)}
                    >
                      1
                    </button>

                    {/* Dots before middle pages */}
                    {currentPage > 4 && totalPages > 6 && <span className="dots">...</span>}

                    {/* Middle pages */}
                    {Array.from({ length: Math.min(5, totalPages - 2) }, (_, index) => {
                      const start = Math.max(2, currentPage - 2);
                      const pageNumber = start + index;
                      if (pageNumber >= totalPages) return null;
                      return (
                        <button
                          key={pageNumber}
                          className={`page ${currentPage === pageNumber ? "active" : ""}`}
                          onClick={() => goToPage(pageNumber)}
                        >
                          {pageNumber}
                        </button>
                      );
                    })}

                    {/* Dots before last page */}
                    {currentPage < totalPages - 3 && totalPages > 6 && <span className="dots">...</span>}

                    {/* Always show last page if not already shown */}
                    {totalPages > 1 && (
                      <button
                        className={`page ${currentPage === totalPages ? "active" : ""}`}
                        onClick={() => goToPage(totalPages)}
                      >
                        {totalPages}
                      </button>
                    )}

                    {/* Page Input (jump to) */}
                    <input
                      type="number"
                      className="page-input"
                      value={inputPage}
                      onChange={handlePageInput}
                      onKeyDown={(e) => {
                        if (e.key === "Enter") {
                          const page = Math.max(1, Math.min(Number(inputPage), totalPages));
                          goToPage(page);
                        }
                      }}
                      min="1"
                      max={totalPages}
                    />

                    {/* Next Button */}
                    <button
                      className="next"
                      onClick={() => goToPage(currentPage + 1)}
                      disabled={currentPage === totalPages}
                    >
                      &raquo;
                    </button>
                  </div>
            </div>

          </div>
        </div>
      </div>

    </>
  );
}

export default ProfitShare;
